import { patch } from 'bootstrap/load-snabbdom';
import { VNode } from 'snabbdom/vnode';
import { IIncidentData, IMessages } from './model';

function InfoLayout({
	data,
	userName,
	scn,
	messages,
} : {
	data : IIncidentData;
	userName : string;
	scn : number;
	messages : IMessages;
}) {
	return <div className="customer-list-dialog row show-grid">
		<div className="col-sm-12 col-md-6">
			<div className="margin-bottom-2 text-align-left">
				<span className="label">ID</span>
				<p>{data.id}</p>
			</div>
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.datum}</span>
				<p>{(new Date(data.creationDate)).toLocaleDateString(document.documentElement.lang)}</p>
			</div>
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.customerListNr}</span>
				<p>{scn ? scn : '-'}</p>
			</div>
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.customerName}</span>
				<p>{userName ? userName : '-'}</p>
			</div>
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.incidentType}</span>
				<p>{data.type.charAt(0).toUpperCase() + data.type.substring(1).toLowerCase()}</p>
			</div>
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.title}</span>
				<p>{data.title}</p>
			</div>
			<div className="text-align-left">
				<span className="label">{messages.internalDescription}</span>
				<p>{data.internalDescription ? data.internalDescription : '-'}</p>
			</div>
			<div className="text-align-left">
				<span className="label">{messages.location}</span>
				<p>{data.location}</p>
			</div>
		</div>
		<div className="col-sm-12 col-md-6">
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.description}</span>
				<p>{data.description}</p>
			</div>
			<div className="margin-bottom-2 text-align-left">
				<span className="label">{messages.workaround}</span>
				<p>{data.partnerWorkaround ? data.partnerWorkaround : '-'}</p>
			</div>
			{data.attributes.map(elem => {
				return <div className="margin-bottom-2 text-align-left">
					<span className="label">{elem.label}</span>
					<p>{elem.value}</p>
				</div>;
			})}
		</div>
	</div>;
}

export class IncidentInfo {
	private target : HTMLElement | VNode;
	private data : IIncidentData;
	private userName : string;
	private scn : number;
	private messages : IMessages;

	constructor(
		target : HTMLElement,
		data : IIncidentData,
		userName : string,
		scn : number,
		messages : IMessages,
	) {
		this.target = target;
		this.data = data;
		this.userName = userName;
		this.scn = scn;
		this.messages = messages;
	}

	public render() {
		this.target = patch(
			this.target,
			<InfoLayout
				data={this.data}
				userName={this.userName}
				scn={this.scn}
				messages={this.messages}
			/>,
		);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/IncidentInfo.tsx